<template>
  <div class="row reverse-mobile justify-content-center">
    <UserMenu></UserMenu>

    <div class="col-12 col-md-9 center-content">
      <CommunityCard class="p-4">
        <h3 class="mb-4 text-inherit">Update Details</h3>

        <div class="alert alert-danger" v-if="errorFound">
          <strong>Whoops!</strong> We had some trouble updating your details
        </div>
        <form style="max-width: 60%" @submit.prevent="requestDetailsUpdate">
          <div class="form-group">
            <label for="inputFirstName">First Name</label>
            <input
              v-model="firstNameInp"
              type="text"
              class="form-control mb-3"
              id="inputFirstName"
              aria-describedby="inputFirstname"
              v-bind:placeholder="user.first_name"
            />
            <label for="inputLastName">Last Name</label>
            <input
              v-model="lastNameInp"
              type="text"
              class="form-control mb-3"
              id="inputLastName"
              aria-describedby="inputLastName"
              v-bind:placeholder="user.last_name"
            />
            <label for="inputTelephoneNumber">Telephone Number</label>
            <input
              v-model="phoneInp"
              type="text"
              class="form-control mb-3"
              id="inputTelephoneNumber"
              aria-describedby="inputTelephoneNumber"
              v-bind:placeholder="user.mobile_phone"
            />
          </div>
          <button
            id="sendButton"
            type="submit"
            :disabled="!btnEnabled"
            :class="{
              'btn my-4': true,
              'btn-primary': btnEnabled,
              'btn-disabled': !btnEnabled,
            }"
          >
            Save
          </button>
        </form>
      </CommunityCard>

      <Footer />
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
import UserService from "../services/user.service";
import CommunityCard from "../components/CommunityCard";
import Footer from "../components/Footer";

export default {
  name: "MyDetailsChange",
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    btnEnabled() {
      return (
        this.firstNameInp.trim() ||
        this.lastNameInp.trim() ||
        this.phoneInp.trim()
      );
    },
  },
  components: {
    UserMenu,
    CommunityCard,
    Footer,
  },
  data() {
    return {
      detailsSent: false,
      errorFound: false,
      firstNameInp: "",
      lastNameInp: "",
      phoneInp: "",
    };
  },
  methods: {
    requestDetailsUpdate: function() {
      UserService.requestDetailsUpdate(
        this.user.id,
        this.firstNameInp,
        this.lastNameInp,
        this.phoneInp
      )
        .then(() => {
          this.detailsSent = true;
          this.errorFound = false;
          vm.$swal
            .mixin({
              customClass: {
                confirmButton: "btn btn-success",
                cancelButton: "btn btn-danger",
              },
              buttonsStyling: false,
            })
            .fire("Updated!", "Your details have been updated.", "success");
        })
        .catch(() => {
          this.errorFound = true;
          this.detailsSent = false;
        });
    },
  },
};
</script>

<style scoped></style>
